<template>
    <v-card>
        <v-card-title>
            <search v-model="search"/>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="openAdd" v-if="userIsFleetManager">Add</v-btn>
            <v-dialog persistent v-model="dialog" max-width="500px">
                <Form
                    v-model="model"
                    @add="submitAdd($event.id, $event.model)"
                    @edit="submitUpdate($event.id, $event.model)"
                >
                    <template v-slot:header>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=false" icon text>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:actions>
                        <v-btn @click="dialog=false">Cancel</v-btn>
                    </template>
                </Form>
            </v-dialog>
        </v-card-title>

        <v-data-table
            :items="serviceRequirements"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :search="search"
            :loading="$wait.is(['loading service requirements'])"
            :footer-props.sync="footerProps"
            :options.sync="options"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr @click="userIsFleetManager ? openEdit(props.item) : null">
                    <td>{{props.item.shortName}}</td>
                    <td>{{props.item.longName}}</td>
                    <td
                        v-if="props.item.hasSecondaryRequirement"
                    >{{props.item.intervalType}} / {{props.item.intervalType2}}
                    </td>
                    <td v-else>{{props.item.intervalType}}</td>
                    <td>{{props.item.serviceType | typeString}}</td>
                    <td
                        v-if="props.item.hasSecondaryRequirement"
                    >{{props.item.tolerance + " " + props.item.toleranceUnits}} / {{props.item.tolerance2 + " " + props.item.toleranceUnits2}}
                    </td>
                    <td v-else>{{props.item.tolerance + " " + props.item.toleranceUnits}}</td>
                    <td width="76px" class="pl-0" v-if="userIsFleetManager">
                        <v-btn @click="openEdit(props.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
  import Form from './Form.vue';
  import Search from '../Search.vue';
  import ServiceRequirements from './ServiceRequirementsClient.vue';
  import {TaskType} from '../../models/enums';
  import {Event} from '../../plugins/bus';

  export default {
    components: {
      Form,
      Search
    },
    mixins: [ServiceRequirements],
    data() {
      return {
        serviceRequirements: [],
        dialog: false,
        search: '',
        options: {
          itemsPerPage: 50,
          sortBy: ['shortName']
        },
        footerProps: {
          itemsPerPageOptions: [10, 50, 100]
        },
        headers: [{text: 'Display Name', value: 'shortName'}, {text: 'Description', value: 'longName'}, {text: 'Hrs/km', value: 'intervalType'}, {text: 'Type', value: 'type'}, {text: 'Tolerance', value: 'tolerance'}],
        model: {}
      };
    },
    methods: {
      openAdd() {
        this.model = {};
        this.dialog = true;
      },
      openEdit(serviceRequirement) {
        this.model = {...serviceRequirement}; // spread operator intentionally used to create clone
        this.dialog = true;
      },
      async submitAdd(id, model) {
        const result = await this.addServiceRequirement(id, model);
        if (result.status === 201) {
          this.dialog = false;
          this.serviceRequirements = await this.getServiceRequirements();
        }
      },
      async submitUpdate(id, model) {
        const result = await this.updateServiceRequirement(id, model);
        if (result.status === 204) {
          this.dialog = false;
          this.serviceRequirements = await this.getServiceRequirements();
        }
      }
    },
    filters: {
      typeString(type) {
        switch (type) {
          case TaskType.PreventativeMaintenance:
            return 'Preventative Maintenance';
          case TaskType.MajorService:
            return 'Major Service';
          case TaskType.Brakes:
            return 'Brake Check';
          case TaskType.ContainerInspection:
            return 'Container Inspection';
        }
      }
    },
    async mounted() {
      this.serviceRequirements = await this.getServiceRequirements();

      if (this.userIsFleetManager) {
        this.headers.push({value: 'id'}); // add edit column
      }
    }
  };
</script>
